import styles from './StageQualityStopModal.module.css';

import FileIcon from 'assets/svg/icons/icon_file-01.svg';

import Modal from 'ui/Modal';
import SwitchWidget from 'components/Widgets/Switch';
import { FormProvider, useForm } from 'react-hook-form';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { productionStore } from 'store/mobx/production.store';
import useAlert from 'hooks/useAlert';
import AppendFilesModal from './AppendFilesModal';
import RegularButton from 'ui/RegularButton';
import FormTextArea from 'ui/formItems/FormTextArea';
import FileUploader from '../../../../../../ui/FileUploader';

const StageQualityStopModal = observer(({ open, setOpen, node }) => {
  const formContext = useForm({
    defaultValues: {
      params: { passed: false },
    },
  });
  const { handleSubmit, setValue, watch, reset } = formContext;
  const { showAlert } = useAlert();
  const { stopProcessIteration } = productionStore;
  const [appendFilesShow, setAppendFilesShow] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);

  useEffect(() => {
    setValue('params.type', 'quality_control');

    return () => {
      reset();
    };
  }, []);

  const isActive = watch('isActive');

  const closeModal = () => {
    reset();
    setOpen(false);
  };

  const onSubmit = async (data) => {
    sureStopPrcessIterationAlert(async () => {
      const res = await stopProcessIteration(node, data);
      if (res.status) closeModal();
      else errorCommonAlert(res.message);
    });
  };

  const handleSwitchChange = () => {
    setValue('params.passed', !isActive);
  };

  const handleAddFile = async (files) => {
    setValue('files', files);
  };

  const errorCommonAlert = (message) => showAlert(`${message}`, 'error');

  const sureStopPrcessIterationAlert = (callback) =>
    showAlert(
      'После завершения этапа редактирование данных контроля качества невозможно. Пожалуйста, убедитесь, что данные заполнены корректно перед завершением.',
      'sure',
      callback,
    );

  return (
    <>
      <Modal
        title="Завершить этап контроля качества"
        onClose={closeModal}
        onSubmit={handleSubmit(onSubmit)}
        open={open}
        submitText="Сохранить"
      >
        <FormProvider {...formContext}>
          <div className={styles.container}>
            <div className={styles.wrapperSwitch}>
              <div>Соответствие</div>
              <div className={styles.switch}>
                <SwitchWidget selected={isActive} onChange={handleSwitchChange} />
              </div>
            </div>
            <div className={styles.wrapperDescription}>
              <FormTextArea
                name="params.description"
                className={styles.description}
                placeholder="Введите примечание"
              />
            </div>

            {/*<div className={styles.filesContainer}>*/}
            {/*  <div className={styles.filesHeader}>*/}
            {/*    <span>Прикрепленные файлы:</span>*/}
            {/*    <RegularButton*/}
            {/*      text="Выбрать"*/}
            {/*      color="primary"*/}
            {/*      variant="outlined"*/}
            {/*      onClick={() => setAppendFilesShow(true)}*/}
            {/*    />*/}
            {/*  </div>*/}
            {/*  <div className={styles.files}>*/}
            {/*    {selectedFiles.map((item, index) => (*/}
            {/*      <div className={styles.fileContent} key={index}>*/}
            {/*        <img src={FileIcon} alt="logo-file" />*/}
            {/*        <span>{item.name}</span>*/}
            {/*      </div>*/}
            {/*    ))}*/}
            {/*    {selectedFiles.length === 0 && (*/}
            {/*      <span className={styles.emptyList}>Список пуст</span>*/}
            {/*    )}*/}
            {/*  </div>*/}
            {/*</div>*/}

            <div className={styles.filesContainer}>
              <div className={styles.filesHeader}>
                <span>Прикрепленные файлы:</span>
              </div>
              <div className={styles.files}>
                <FileUploader
                  multiple={true}
                  customStyles={{mainContainer: styles.fileUploadContainer}}
                  listPosition="bottom"
                  onFilesChange={(files) => handleAddFile(files)}
                  onError={(error) => errorCommonAlert(error)}
                />
              </div>
            </div>
          </div>
        </FormProvider>
      </Modal>

      {appendFilesShow && (
        <AppendFilesModal
          isOpen={appendFilesShow}
          onClose={() => setAppendFilesShow(false)}
          onSubmit={setSelectedFiles}
          selectedSourceFiles={selectedFiles}
          node={node}
        />
      )}
    </>
  );
});

export default StageQualityStopModal;
